import type { StrictOmit } from "ts-essentials";
import type { HistoryCardProps } from "~/components/DetailsCards";
import { HistoryCard } from "~/components/DetailsCards";
import { renderForeignResource } from "./renderForeignResource";

type LqsHistoryCardProps = StrictOmit<
  HistoryCardProps,
  "renderForeignResource"
>;

export function LqsHistoryCard(props: LqsHistoryCardProps) {
  return (
    <HistoryCard {...props} renderForeignResource={renderForeignResource} />
  );
}
